import { type ComponentProps, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type VersionsListProps = ComponentProps<'div'>;

export const VersionsList = memo(({ className, ...restOfProps }: VersionsListProps) => {
  return <div className={cn('flex w-full flex-col gap-2', className)} data-testid="VERSIONS_LIST" {...restOfProps} />;
});

VersionsList.displayName = 'VersionsList';
